import React, { useState } from 'react';
import { Container, Button, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import '../../../assets/css/Customer/CustomerDashboard/CustomerDateTimeSchedule.css';

const CustomerDateTimeSchedule = () => {
  const navigate = useNavigate();
  const [selectedTime, setSelectedTime] = useState('12:55 PM');
  const [selectedDate, setSelectedDate] = useState(new Date().toISOString().split('T')[0]);

  const handleTimeChange = (e) => {
    setSelectedTime(e.target.value);
  };

  const handleDateChange = (e) => {
    setSelectedDate(e.target.value);
  };

  const handleBack = () => {
    navigate(-1);
  };

  const handleDone = () => {
    navigate('/customer-instant-ride');
  };

  return (
    <div className="CustomerDateTimeSchedule-wrapper">
      {/* Header */}
      <div className="CustomerDateTimeSchedule-header">
        <Button 
          variant="link" 
          className="CustomerDateTimeSchedule-back-btn"
          onClick={handleBack}
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M15 18L9 12L15 6" stroke="#2E2E2E" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </Button>
        <h1 className="CustomerDateTimeSchedule-title">Date Time Schedule</h1>
      </div>

      <Container className="CustomerDateTimeSchedule-container">
        {/* Question Section */}
        <div className="CustomerDateTimeSchedule-question-section">
          <p className="CustomerDateTimeSchedule-question">
            What time would you want to be picked up?
          </p>
        </div>

        {/* Date Picker */}
        <div className="CustomerDateTimeSchedule-picker-section">
          <Form.Group className="CustomerDateTimeSchedule-form-group">
            <Form.Label className="CustomerDateTimeSchedule-label">
              Select Date
            </Form.Label>
            <Form.Control
              type="date"
              value={selectedDate}
              onChange={handleDateChange}
              className="CustomerDateTimeSchedule-date-input"
            />
          </Form.Group>

          {/* Time Display */}
          <div className="CustomerDateTimeSchedule-time-display">
            <p className="CustomerDateTimeSchedule-time-label">Time:</p>
            <p className="CustomerDateTimeSchedule-time-value">{selectedTime}</p>
          </div>

          {/* Time Picker */}
          <Form.Group className="CustomerDateTimeSchedule-form-group">
            <Form.Control
              type="time"
              value={selectedTime}
              onChange={handleTimeChange}
              className="CustomerDateTimeSchedule-time-input"
            />
          </Form.Group>
        </div>

        {/* Done Button */}
        <Button 
          className="CustomerDateTimeSchedule-done-btn"
          onClick={handleDone}
        >
          Done
        </Button>
      </Container>
    </div>
  );
};

export default CustomerDateTimeSchedule;